// extracted by mini-css-extract-plugin
export default {"header-link":"ModuleHeader___moduleHeader-module__header-link___NiFya","icon-button":"ModuleHeader___moduleHeader-module__icon-button___B0A5g"};